import type { ITrainingApply, TrainingApplyStatus } from "@bbj-types/apply/training";
import type { ITrainingOffer, ITrainingOfferProvider } from "@bbj-types/offer";
import type { ObjectId, Override } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "../axios";

export interface IGetTrainingAppliesByCandidateAutocompleteParams {
  status?: TrainingApplyStatus[];
}

export interface IGetTrainingAppliesByCandidateAutocomplete {
  data: Override<
    Pick<ITrainingApply, "_id" | "offer">,
    {
      offer: Override<
        Pick<
          ITrainingOffer,
          "name" | "address" | "provider" | "trainingDuration" | "trainingStartDate" | "trainingEndDate"
        >,
        {
          provider?: Pick<ITrainingOfferProvider, "name">;
        }
      >;
    }
  >[];
}

export const useGetTrainingAppliesByCandidateAutocomplete = () => {
  const [state, execute, cancel] = axios<IGetTrainingAppliesByCandidateAutocomplete, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId, params: IGetTrainingAppliesByCandidateAutocompleteParams) => {
      return execute({
        url: `/applies/training/candidate/${candidateId}/autocomplete`,
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
